<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { formatCount } from '../helpers';
import PostCommentView from './PostCommentView.vue';

const props = defineProps({
  source: { type: Object, required: true },
});

const { t, locale } = useI18n();
const telegram = computed(() => props.source.telegram || {});
const initials = computed(() => (telegram.value.chat_title || 'T').slice(0, 1));
const link = computed(() => telegram.value.message_link || props.source.url);
</script>

<template>
  <div class="flex flex-col gap-3">
    <div
      class="flex items-center gap-3 p-3 rounded-lg bg-n-alpha-1 border border-n-weak"
    >
      <span
        class="grid flex-shrink-0 size-10 rounded-full place-items-center bg-gradient-to-br from-[#37AEE2] to-[#1E96C8] text-white text-base font-bold"
      >
        {{ initials }}
      </span>
      <div class="flex flex-col min-w-0 flex-1">
        <span class="text-[13px] font-semibold text-n-slate-12 truncate">
          {{ telegram.chat_title }}
        </span>
        <span class="text-xs text-n-slate-11">
          {{ t('MULTICHAT.SOURCE.TELEGRAM.GROUP') }}
          <template v-if="telegram.members">
            ·
            {{
              t('MULTICHAT.SOURCE.TELEGRAM.MEMBERS', {
                count: formatCount(telegram.members, locale),
              })
            }}
          </template>
        </span>
      </div>
      <a
        v-if="link"
        :href="link"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-1 text-xs font-medium text-n-blue-11 hover:underline flex-shrink-0"
      >
        {{ t('MULTICHAT.SOURCE.TELEGRAM.OPEN_MESSAGE') }}
        <span class="i-lucide-external-link size-3" />
      </a>
    </div>
    <PostCommentView v-if="source.post" :source="source" />
  </div>
</template>
